import { render } from "./PharmaceuticalAndNutraceutical.vue?vue&type=template&id=3db05c94"
import script from "./PharmaceuticalAndNutraceutical.vue?vue&type=script&lang=js"
export * from "./PharmaceuticalAndNutraceutical.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/PharmaceuticalAndNutraceutical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3db05c94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3db05c94', __exports__)) {
    api.reload('3db05c94', __exports__)
  }
  
  module.hot.accept("./PharmaceuticalAndNutraceutical.vue?vue&type=template&id=3db05c94", () => {
    api.rerender('3db05c94', render)
  })

}


export default __exports__